/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */
/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

// Alias
import Input from '../../input';

export default Input;



// WEBPACK FOOTER //
// ./components/forms/input/index.jsx